import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getNameByIdWorkoutSelector from 'modules/workout/redux/selectors/get-name-by-id/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import Row from 'components/Row.js'
import Button from 'components/Button/index.js'
import Icon from 'components/Icon/index.js'
import CheckMarkIcon from 'components/Icon/icons/check-mark/index.js'
import { EditIcon } from 'components/Icon/icons/edit/index.js'
import {
  saveWorkoutAction,
  updateNameWorkoutAction
} from '@gymaholic/packages'
import Input from 'components/Input/index.js'
import WorkoutNameText from 'pages/Workout/components/Workout/components/NameText/index.js'

const ICON_SIZE_IN_PX = '25px'

/**
 * @param props
 * @param props.id
 * @param props.onClickName
 * @param props.isAboutVisible
 * @returns {JSX.Element}
 * @constructor
 */
export default function WorkoutEditName (props) {
  const {
    id
  } = props
  const name = useSelector(getNameByIdWorkoutSelector(id))
  const [isEditing, setIsEditing] = React.useState(false)
  const dispatch = useDispatch()

  const handleChange = (event) => {
    dispatch(updateNameWorkoutAction(event.target.value))
  }

  let element
  if (isEditing) {
    element = (
      <Input
        value={name}
        onChange={handleChange}
        isFocused
        style={{
          minHeight: 'auto',
          width: '100%'
        }}
      />
    )
  } else {
    element = (
      <WorkoutNameText
        {...props}
      />
    )
  }

  const handleClick = () => {
    if (isEditing) {
      setIsEditing(false)
      dispatch(saveWorkoutAction(id))
      return
    }
    setIsEditing(true)
  }

  return (
    <Row
      ac
    >
      {element}
      <Row
        mx
        ac
      >
        <Button
          onClick={handleClick}
          style={{
            height: 'auto'
          }}
          hoverableProps={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Icon
            icon={isEditing ? CheckMarkIcon : EditIcon}
            size={ICON_SIZE_IN_PX}
          />
        </Button>
      </Row>
    </Row>
  )
}
